// login.js
'use strict';
import addModal from '../action/addModal.js';
import pushToastr from '../action/pushToastr.js';
import toggleModal from '../action/toggleModal.js';
import getOperationData from '../selector/getOperationData.js';
import { login as loginModal } from '../resource/modalId.js';
import { getIsChinaPartner, getPartnerName } from '../resource/partner.js';
import i18n from '../resource/i18n.js';
import { createLoginPromise } from '../resource/loginPromise.js';

/**
 * Login
 * @kind action
 * @return {Promise} Action promise.
 */
const login =
  ({ isRequireDiamond = false } = {}) =>
  async (dispatch, getState) => {
    if (getIsChinaPartner()) {
      return dispatch(
        pushToastr({
          textKey: 're_login_on_partner',
          textKeyOption: {
            partnerName: i18n.t(getPartnerName()),
          },
          color: 'error',
        })
      );
    }

    const welcomeBackData = getOperationData(getState(), ['welcomeBack']);
    if (welcomeBackData?.userId) {
      return dispatch(
        addModal({
          id: loginModal.WELCOME_BACK,
          isHigherThanAll: true,
          transitionStatus: 'comingFromBottom',
        })
      );
    }

    if (isRequireDiamond) {
      return dispatch(
        addModal({
          id: loginModal.METHOD_SELECT,
          isHigherThanAll: true,
          transitionStatus: 'comingFromBottom',
        })
      );
    }

    const promise = createLoginPromise();
    dispatch(
      toggleModal({
        modalId: 'ModalChooseEntryOption',
        modalOption: {
          isHigherThanAll: true,
        },
        isOpen: true,
      })
    );
    await promise;
    return;
  };

export default login;
